import { render, staticRenderFns } from "./LoadingOverlayLayerLegacy.vue?vue&type=template&id=2d3bc18f&scoped=true"
import script from "./LoadingOverlayLayerLegacy.vue?vue&type=script&lang=js"
export * from "./LoadingOverlayLayerLegacy.vue?vue&type=script&lang=js"
import style0 from "./LoadingOverlayLayerLegacy.vue?vue&type=style&index=0&id=2d3bc18f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bc18f",
  null
  
)

export default component.exports